import { Reducer } from '@reduxjs/toolkit';
import { FluxStandardAction } from 'redux-promise-middleware';
import { CustomAppConfig, CustomAppConfigResponse } from '../../../types/customApps';

export type CustomAppsSettingsState = {
  readonly configs: CustomAppConfig[];
  readonly fetchingConfigs: boolean;
  readonly savingConfig: boolean;
  readonly deletingConfig: boolean;
};

const initialState: CustomAppsSettingsState = {
  configs: [],
  fetchingConfigs: false,
  savingConfig: false,
  deletingConfig: false,
};

const reducer: Reducer<CustomAppsSettingsState, FluxStandardAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'FETCH_CUSTOM_APP_CONFIGS_PENDING': {
      return {
        ...state,
        fetchingConfigs: true,
      };
    }
    case 'FETCH_CUSTOM_APP_CONFIGS_REJECTED': {
      return {
        ...state,
        fetchingConfigs: false,
      };
    }
    case 'FETCH_CUSTOM_APP_CONFIGS_FULFILLED': {
      const response: CustomAppConfigResponse = action.payload?.data;
      return {
        ...state,
        configs: response.configs,
        fetchingConfigs: false,
      };
    }
    case 'CREATE_CUSTOM_APP_CONFIG_PENDING': {
      return {
        ...state,
        savingConfig: true,
      };
    }
    case 'CREATE_CUSTOM_APP_CONFIG_REJECTED': {
      return {
        ...state,
        savingConfig: false,
      };
    }
    case 'CREATE_CUSTOM_APP_CONFIG_FULFILLED': {
      const newConfig: CustomAppConfig = action.payload.data;
      return {
        ...state,
        configs: [...state.configs, newConfig],
        savingConfig: false,
      };
    }
    case 'UPDATE_CUSTOM_APP_CONFIG_PENDING': {
      return {
        ...state,
        savingConfig: true,
      };
    }
    case 'UPDATE_CUSTOM_APP_CONFIG_REJECTED': {
      return {
        ...state,
        savingConfig: false,
      };
    }
    case 'UPDATE_CUSTOM_APP_CONFIG_FULFILLED': {
      const updatedConfig: CustomAppConfig = action.payload.data;
      return {
        ...state,
        configs: state.configs.map(config =>
          config.id === updatedConfig.id ? updatedConfig : config
        ),
        savingConfig: false,
      };
    }
    case 'DELETE_CUSTOM_APP_CONFIG_PENDING': {
      return {
        ...state,
        deletingConfig: true,
      };
    }
    case 'DELETE_CUSTOM_APP_CONFIG_REJECTED': {
      return {
        ...state,
        deletingConfig: false,
      };
    }
    case 'DELETE_CUSTOM_APP_CONFIG_FULFILLED': {
      const configId = action.meta.configId;
      return {
        ...state,
        configs: state.configs.filter(config => config.id !== configId),
        deletingConfig: false,
      };
    }
  }
  return state;
};

export default reducer;
